import { useMountTo } from '../hooks';
export function Sidebar(props) {
    const { children } = props;
    return useMountTo('sidebar', children);
}
